
function getOutput(term) {
  let output = ""
  // The line buffer is a circular buffer with a max size of scrollback + rows.
  // Writes that require new lines beyond that limit recycle top lines (FIFO) and re-append them at the bottom with the new content.
  // This circular behavior is important to know, as it leads to a "moving index" once that limit is hit (from content perspective).
  for (let line = 0; line < term.buffer.active.length; line++) {
    let text = term.buffer.active.getLine(line).translateToString(true)
    if (!text || text === "") {
      continue
    }
    output += (text + '\n')
  }

  return output
}

function getUserFromTitle(title){
  let userEndIndex = title.indexOf("@")
  return title.substring(0, userEndIndex)
}

function getHostFromTitle(title) {
  let userEndIndex = title.indexOf("@")
  let hostEndIndex = title.indexOf(":")
  return title.substring(userEndIndex + 1, hostEndIndex)
}

function getPwdFromTitle(title) {
  let hostEndIndex = title.indexOf(":")
  return title.substr(hostEndIndex)
}

function splitTitle(title) {
  console.log("splitTitle: title:", title)
  let userEndIndex = title.indexOf("@")
  let hostEndIndex = title.indexOf(":")
  let user = title.substring(0, userEndIndex)
  let host = title.substring(userEndIndex + 1, hostEndIndex)
  let pwd = title.substr(hostEndIndex)
  return {user, host, pwd}
}

export default {
  getOutput,
  getUserFromTitle,
  getHostFromTitle,
  getPwdFromTitle,
  splitTitle,
}
